// Aperçu « vue externe » d'un administrateur : l'interface le traite comme un compte externe (rôle external, projets
// où il est invité, démos, viewer en présentation). L'interface seulement : ses droits Firestore restent ceux d'un
// administrateur. Mémorisé dans le navigateur (tous les onglets) ; sans stockage, l'aperçu dure jusqu'au rechargement.
const KEY = 'hyprview.externalPreview';
const EVENT = 'hyprview-external-preview';
let fallback = false;  // stockage indisponible (navigation privée…)

export function readExternalPreview() {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return fallback;
  }
}

export function setExternalPreview(on) {
  fallback = on;
  try {
    if (on) window.localStorage.setItem(KEY, '1');
    else window.localStorage.removeItem(KEY);
  } catch { /* stockage indisponible : fallback */ }
  window.dispatchEvent(new Event(EVENT));
}

// Appelle onChange(actif) quand l'aperçu change, dans cet onglet ou un autre ; renvoie de quoi arrêter l'écoute.
export function watchExternalPreview(onChange) {
  const local = () => onChange(readExternalPreview());
  const other = e => { if (e.key === KEY) local(); };
  window.addEventListener(EVENT, local);
  window.addEventListener('storage', other);
  return () => { window.removeEventListener(EVENT, local); window.removeEventListener('storage', other); };
}

// Profil vu par l'interface : un administrateur en aperçu devient externe (realRole garde son rôle réel).
export const effectiveProfile = (profile, preview) => (profile && preview && profile.role === 'admin'
  ? { ...profile, role: 'external', realRole: 'admin', preview: true }
  : profile);
